import {
  inject
} from '@angular/core';

import {
  CanActivateFn,
  Router
} from '@angular/router';

import {
  AuthService
} from './auth.service';


export const superAdminGuard:
  CanActivateFn = () => {

    const auth =
      inject(AuthService);

    const router =
      inject(Router);


    /*
     * Não está autenticado.
     */
    if (!auth.isLoggedIn()) {

      return router.createUrlTree([
        '/login'
      ]);
    }


    /*
     * Está autenticado e é
     * SUPER_ADMIN.
     */
    if (auth.isSuperAdmin()) {

      return true;
    }


    /*
     * Usuário comum tentou entrar
     * no painel global.
     */
    return router.createUrlTree([
      '/admin'
    ]);
  };